import api from './api';
import { API_ENDPOINTS } from '../utils/constants';
import { storage } from '../utils/storage';

class AuthService {
  async login(username, password) {
    try {
      const response = await api.post(API_ENDPOINTS.LOGIN, { username, password });
      const { token } = response.data;
      
      console.log('Login successful, token received');
      
      // Store token (this will also decode and store user)
      storage.setToken(token);
      
      // Get the stored user
      const user = storage.getUser();
      console.log('User stored:', user);
      
      return { success: true, user };
    } catch (error) {
      console.error('Login error:', error);
      return { 
        success: false, 
        error: error.response?.data?.message || 'Login failed' 
      };
    }
  }

  logout() {
    storage.clear();
  }

  getCurrentUser() {
    return storage.getUser();
  }

  isAuthenticated() {
    return !!storage.getToken();
  }
}

export default new AuthService();